import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text/Text';
import {
    InputElement,
    StyledInput,
} from '~/shared/components/form/components/controllable-elements/input-element';
import { Hr } from '~/features/navigation/components/search/styled';
import { breakpoints } from '~/theme/breakpoints';

export const Spacer = styled(Hr)(({ theme }) => ({
    marginTop: theme.space[5],
    marginBottom: theme.space[3],
}));

export const PromoCodeItem = styled.li(({ theme }) => ({
    display: 'grid',
    gap: theme.space[2],
    textAlign: 'left',
    alignItems: 'center',
    gridTemplateColumns: 'min-content 1fr min-content min-content',
}));

export const InputPromo = styled(InputElement)(({ theme }) => ({
    ...theme.mixins.useTextStyle('formsLabel'),
    backgroundColor: theme.colors.grey10,
    color: theme.colors.black,
    textAlign: 'left',
    padding: `${theme.space[2]}`,
}));

export const GiftCertificateCaption = styled(Text)(({ theme }) => ({
    padding: `${theme.space[1]} 0 ${theme.space[2]}`,
}));

export const GiftCertificateWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.space[2],

    [breakpoints.md]: {
        gridTemplateColumns: '2fr 1fr auto',
    },
}));

export const GiftCertificateInput = styled(StyledInput)(({ theme }) => ({
    backgroundColor: `${theme.colors.grey10}`,
    border: `1px solid ${theme.colors.grey50}`,
    '&:focus': {
        boxShadow: theme.shadows.accessibilityTextField,
    },
    [breakpoints.xs]: {
        paddingRight: theme.space[2],
        paddingLeft: theme.space[2],
    },
}));

export const GiftCertificateCVC = styled(GiftCertificateInput)(() => ({
    width: 60,
    [breakpoints.xs]: {
        width: 46,
    },
}));

export const GiftCertificateElementsGroup = styled.div(({ theme }) => ({
    marginBottom: theme.space[1],
}));
